import moment from 'moment';
import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { accessTypes } from "../../helpers/Utils";

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const RecentOrders = ({ bookings }) => {
  // Get user from Redux store
  const { user } = useSelector(state => state.authUser);

  // Memoize sorted bookings
  const sortedBookings = useMemo(() => {
    if (!bookings || bookings.length === 0) return [];
    return bookings.sort((a, b) => (a.bookingDate < b.bookingDate) ? 1 : ((b.bookingDate < a.bookingDate) ? -1 : 0));
  }, [bookings]);

  if (!sortedBookings || sortedBookings.length === 0) {
    return (
      <Card style={{ paddingTop: 0, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            borderBottom: '1px solid hsl(var(--border))',
            padding: '1.5rem 1.5rem 0.75rem 1.5rem',
            flexShrink: 0
          }}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '0.25rem',
            flex: 1
          }}>
            <CardTitle style={{ fontSize: '1.125rem', fontWeight: 600 }}>Recent Bookings</CardTitle>
            <CardDescription style={{ fontSize: '0.875rem', color: '#6b7280' }}>
              Recent bookings for the selected date range
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent style={{
          padding: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
          color: '#6b7280',
          fontSize: '0.875rem'
        }}>
          <svg
            style={{ width: '48px', height: '48px', marginBottom: '1rem', opacity: 0.3 }}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <p style={{ margin: 0, textAlign: 'center' }}>No recent bookings available</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card style={{ paddingTop: 0, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          borderBottom: '1px solid hsl(var(--border))',
          padding: '1.5rem 1.5rem 0.75rem 1.5rem',
          flexShrink: 0
        }}
      >
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '0.25rem',
          flex: 1,
          minWidth: 0
        }}>
          <CardTitle style={{ fontSize: '1.125rem', fontWeight: 600 }}>Recent Bookings</CardTitle>
          <CardDescription style={{ fontSize: '0.875rem', color: '#6b7280' }}>
            Recent bookings for the selected date range
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent style={{
        padding: '0 1.5rem',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0
      }}>


        {/* Bookings List - Card Style */}
        <div style={{
          // display: 'flex',
          // flexDirection: 'column',
          // gap: '0.5rem',
          // paddingTop: '1.5rem',
          // paddingBottom: '1.5rem',
          // overflowY: 'auto',
          // maxHeight: '500px'
        }}>
          {sortedBookings.map((order, index) => {
            const getStatusColor = () => {
              if (order.status === 'pending' || order.status === 'new') return '#3b82f6'; // Blue
              if (order.status === 'accepted') return '#8b5cf6'; // Purple
              if (order.status === 'active') return '#06b6d4'; // Cyan
              if (order.status === 'completed' || order.status === 'notRated') return '#10b981'; // Green
              if (order.status === 'rated') return '#f59e0b'; // Amber/Orange
              if (order.status === 'rejected') return '#ef4444'; // Red
              if (order.status === 'canceled') return '#6b7280'; // Gray
              return '#6b7280'; // Default gray
            };

            const getStatusBgColor = () => {
              if (order.status === 'pending' || order.status === 'new') return 'rgba(59, 130, 246, 0.1)'; // Blue
              if (order.status === 'accepted') return 'rgba(139, 92, 246, 0.1)'; // Purple
              if (order.status === 'active') return 'rgba(6, 182, 212, 0.1)'; // Cyan
              if (order.status === 'completed' || order.status === 'notRated') return 'rgba(16, 185, 129, 0.1)'; // Green
              if (order.status === 'rated') return 'rgba(245, 158, 11, 0.1)'; // Amber
              if (order.status === 'rejected') return 'rgba(239, 68, 68, 0.1)'; // Red
              if (order.status === 'canceled') return 'rgba(107, 114, 128, 0.1)'; // Gray
              return 'rgba(107, 114, 128, 0.1)'; // Default gray
            };

            return (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  marginBottom: '0.5rem',
                  padding: '0.75rem',
                  backgroundColor: '#f9fafb',
                  border: '1px solid transparent',
                  borderRadius: '0.5rem',
                  transition: 'all 0.2s',
                  cursor: 'pointer',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f4f6';
                  e.currentTarget.style.transform = 'translateX(4px)';
                  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#f9fafb';
                  e.currentTarget.style.transform = 'translateX(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                {/* Status Indicator */}
                <div style={{
                  width: '4px',
                  height: '100%',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  backgroundColor: getStatusColor(),
                  borderRadius: '0.5rem 0 0 0.5rem'
                }} />

                {/* Customer Avatar */}
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  backgroundColor: getStatusBgColor(),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: getStatusColor(),
                  fontWeight: 700,
                  fontSize: '1rem',
                  border: '2px solid #fff',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  flexShrink: 0,
                  marginLeft: '0.5rem' // Add margin to account for color indicator
                }}>
                  {order.customer_name ? order.customer_name.charAt(0).toUpperCase() : '?'}
                </div>

                {/* Booking Info */}
                <div style={{
                  flex: 1,
                  minWidth: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.125rem'
                }}>
                  <span style={{
                    fontSize: '0.875rem',
                    color: '#111827',
                    fontWeight: 600,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    lineHeight: '1.25rem'
                  }}>
                    {order.customer_name || 'Unknown Customer'}
                  </span>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.375rem',
                    flexWrap: 'wrap'
                  }}>
                    <span style={{
                      fontSize: '0.75rem',
                      color: '#6b7280',
                      lineHeight: '1rem'
                    }}>
                      {order.service_name || 'N/A'}
                    </span>
                    {order.service_name && (
                      <span style={{
                        fontSize: '0.75rem',
                        color: '#d1d5db',
                        lineHeight: '1rem'
                      }}>•</span>
                    )}
                    <span style={{
                      fontSize: '0.75rem',
                      color: '#6b7280',
                      lineHeight: '1rem'
                    }}>
                      {order.bookingDate ? moment(order.bookingDate).format('MMM DD, YYYY hh:mm A') : 'N/A'}
                    </span>
                  </div>
                  {accessTypes?.includes(user?.accessType) && order.customer_number && (
                    <span style={{
                      fontSize: '0.75rem',
                      color: '#9ca3af',
                      lineHeight: '1rem',
                      marginTop: '0.125rem'
                    }}>
                      {order.customer_number}
                    </span>
                  )}
                </div>

                {/* Status Badge */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  flexShrink: 0,
                  minWidth: 'fit-content'
                }}>
                  <span
                    style={{
                      fontSize: '0.75rem',
                      fontWeight: 500,
                      padding: '0.25rem 0.625rem',
                      backgroundColor: getStatusBgColor(),
                      color: getStatusColor(),
                      border: 'none',
                      whiteSpace: 'nowrap',
                      borderRadius: '9999px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {order.status === "notRated" ? 'Completed' : capitalize(order.status)}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

// Memoize component to prevent unnecessary re-renders
export default React.memo(RecentOrders, (prevProps, nextProps) => {
  return JSON.stringify(prevProps.bookings) === JSON.stringify(nextProps.bookings);
});